module.exports = __webpack_public_path__ + "img/hr-brown-fluff-dry-14.64b92bca.png";